import { useState } from "react";
import { Loader2 } from "lucide-react";
import RepliesPanel from "@/components/RepliesPanel";
import { isProcessing } from "./campaignModel";
import { DetailHeader, StatsRow, CadenceSummary, ProcessingState, AllClear } from "./CampaignDetailSections";
import { SaveTemplateModal } from "./SaveTemplateModal";
import { ApprovalQueue } from "./ApprovalQueue";
import { ProspectList } from "./ProspectList";

export const CampaignDetail = ({ userId, detail, loading, onBack, onDelete, onSaveTemplate, onApprove, onSkip }) => {
  const [showSaveTemplate, setShowSaveTemplate] = useState(false);
  const c = detail?.campaign;
  const prospects = detail?.prospects || [];
  const queue = detail?.approvalQueue || [];
  const sequences = detail?.sequences || [];
  const processing = isProcessing(c?.status);
  const ready = !processing && c?.status === "ready";

  return (
    <div className="space-y-6" data-testid="campaign-detail">
      <DetailHeader campaign={c} processing={processing} onBack={onBack} onDelete={onDelete} onSaveTemplate={() => setShowSaveTemplate(true)} />
      <SaveTemplateModal open={showSaveTemplate} onClose={() => setShowSaveTemplate(false)} campaign={c} onSave={onSaveTemplate} />

      {!detail && loading ? (
        <div className="flex items-center justify-center py-16" data-testid="campaign-detail-loading">
          <Loader2 className="h-8 w-8 animate-spin text-ism-teal" />
        </div>
      ) : (
        <>
          <StatsRow campaign={c} />
          {c?.cadenceConfig && !processing && <CadenceSummary campaign={c} />}
          {processing && <ProcessingState campaign={c} />}
          {!processing && queue.length > 0 && <ApprovalQueue queue={queue} onApprove={onApprove} onSkip={onSkip} />}
          {ready && <RepliesPanel userId={userId} />}
          {!processing && <ProspectList prospects={prospects} sequences={sequences} />}
          {ready && queue.length === 0 && <AllClear />}
        </>
      )}
    </div>
  );
};
